// extracted by mini-css-extract-plugin
export default {"title":"Phy1TQ","field":"kknA4k","return":"m4MUTR kknA4k","airline":"aurvUK","flight":"K1IJM7 kknA4k","timeChangedIcon":"e4E64u"};